module.exports = __webpack_public_path__ + "img/FeaturePlan.e3adb626.png";